import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import './LoadingCover.sass';

const LoadingCover = () => (
	<div className="ts-loading-shading-mui">
		<CircularProgress className="ts-loading-icon-mui" />
	</div>
);

export default LoadingCover;
